import { LogIn, LogOut } from "lucide-react";
import { useAuth, login } from "@/lib/auth";

export const UserMenu = () => {
  const { user, loading, logout } = useAuth();
  if (loading) return <span className="w-9 h-9" />;
  if (!user)
    return (
      <button onClick={login} data-testid="header-sign-in-btn" className="inline-flex items-center gap-2 h-10 px-3 border border-[#27303E] hover:border-amber-500 rounded-sm font-mono text-xs uppercase tracking-widest text-slate-300 transition-colors duration-200">
        <LogIn size={14} /> <span className="hidden sm:inline">Sign in</span>
      </button>
    );
  return (
    <div className="flex items-center gap-2" data-testid="user-menu">
      {user.picture ? (
        <img src={user.picture} alt={user.name} className="w-9 h-9 rounded-sm border border-[#27303E] object-cover" data-testid="user-avatar" />
      ) : (
        <span className="w-9 h-9 grid place-items-center rounded-sm bg-[#27303E] font-display font-bold" data-testid="user-avatar">{user.name[0]}</span>
      )}
      <span className="hidden lg:block text-sm text-slate-300 max-w-[120px] truncate" data-testid="user-name">{user.name}</span>
      <button onClick={logout} title="Sign out" data-testid="header-sign-out-btn" className="w-9 h-9 grid place-items-center border border-[#27303E] hover:border-red-500 hover:text-red-400 rounded-sm text-slate-400 transition-colors duration-200">
        <LogOut size={15} />
      </button>
    </div>
  );
};
